// extracted by mini-css-extract-plugin
export default {"disclaimer-text":"DisclaimerText--disclaimer-text--T2255","disclaimerText":"DisclaimerText--disclaimer-text--T2255"};